import { http } from '@/utils/http';
import qs from 'qs';

const baseUrl = '/vote/2020project/2020cppcc/controller.php?enews=';

interface IVoteListOption {
  page?: number;
}
export const getBaseInfo = () => {
  return http.get(`${baseUrl}base-info`);
};
// 直播
export const getLive = ({ page }: IVoteListOption) => {
  return http.get(`${baseUrl}live`, {
    params: { page },
  });
};

// 要闻区
export const getCommittee = ({ page }: IVoteListOption) => {
  return http.get(`${baseUrl}committee`, {
    params: { page },
  });
};

// 两会进行时
export const getFocus = ({ page }: IVoteListOption) => {
  return http.get(`${baseUrl}focus`, {
    params: { page },
  });
};

// 重庆加速度
export const getOnGoing = ({ page }: IVoteListOption) => {
  return http.get(`${baseUrl}on-going`, {
    params: { page },
  });
};

// 热点全解读
export const getAcceleration = ({ page }: IVoteListOption) => {
  return http.get(`${baseUrl}acceleration`, {
    params: { page },
  });
};

// 代表委员艾特你
export const getUnscramble = ({ page }: IVoteListOption) => {
  return http.get(`${baseUrl}unscramble`, {
    params: { page },
  });
};

// 成渝双城记
export const getChengdu = ({ page }: IVoteListOption) => {
  return http.get(`${baseUrl}Chengdu`, {
    params: { page },
  });
};

// 融媒连连看
export const getFinancial = ({ page }: IVoteListOption) => {
  return http.get(`${baseUrl}Financial`, {
    params: { page },
  });
};
